module.exports = __webpack_public_path__ + "img/AnalyticsIcon.37b79ea7.svg";